import { defineMessages } from "react-intl";

// The section's own name (sidebar entry, window title) is
// sectionNames.atticInventory in src/intl.ts.
export const sectionMessages = defineMessages({
  stockLookup: {
    id: "C/RWp9",
    defaultMessage: "Stock lookup",
    description: "inventory, stock lookup page title and tab",
  },
  locations: {
    id: "BZWXR7",
    defaultMessage: "Locations",
    description: "inventory, locations page title and tab",
  },
  lots: {
    id: "Wo+XHr",
    defaultMessage: "Lots",
    description: "inventory, lots page title and tab",
  },
  intake: {
    id: "V0NP83",
    defaultMessage: "Intake",
    description: "inventory, intake page title and tab",
  },
  ledger: {
    id: "HVfJOd",
    defaultMessage: "Stock ledger",
    description: "inventory, ledger page title and tab",
  },
  loadFailed: {
    id: "LZ6cN+",
    defaultMessage: "The inventory could not be loaded. Try again.",
    description: "inventory, read failed",
  },
  backToInventory: {
    id: "rLrKFx",
    defaultMessage: "Inventory",
    description: "inventory, TopNav destination tooltip",
  },
});

export const stockMessages = defineMessages({
  subtitle: {
    id: "seVyoy",
    defaultMessage:
      "Scan or type a SKU. On hand is what the units say; sellable is on hand minus the reserve, and is what the web may sell.",
    description: "stock lookup, subtitle",
  },
  skuPlaceholder: {
    id: "n3dvOM",
    defaultMessage: "SKU or barcode",
    description: "stock lookup, search placeholder",
  },
  lookUp: {
    id: "W9kcwf",
    defaultMessage: "Look up",
    description: "stock lookup, search button",
  },
  notFound: {
    id: "J88btw",
    defaultMessage: "No variant has the SKU {sku}.",
    description: "stock lookup, unknown sku",
  },
  prompt: {
    id: "dlATCK",
    defaultMessage: "Enter a SKU to see where it is and what it cost.",
    description: "stock lookup, nothing looked up yet",
  },
  onHand: {
    id: "NcOX9U",
    defaultMessage: "On hand",
    description: "stock, figure label",
  },
  reserved: {
    id: "z/NhI9",
    defaultMessage: "Reserved",
    description: "stock, figure label",
  },
  sellable: {
    id: "Cx2Xz2",
    defaultMessage: "Sellable",
    description: "stock, figure label",
  },
  saleorQuantity: {
    id: "sh0X3Q",
    defaultMessage: "Saleor stock",
    description: "stock, figure label: what Saleor's warehouse row says",
  },
  averageCost: {
    id: "oXnKIG",
    defaultMessage: "Average cost",
    description: "stock, figure label",
  },
  outOfSync: {
    id: "mcEkdk",
    defaultMessage:
      "Saleor's stock does not match sellable. A stock edit was made outside the inventory; run attic_inventory_sync or fix the count here.",
    description: "stock, drift warning",
  },
  none: {
    id: "YChyL0",
    defaultMessage: "none",
    description: "stock, no value",
  },
  unitsTitle: {
    id: "w697OI",
    defaultMessage: "Where it is",
    description: "stock, units card title",
  },
  noUnits: {
    id: "5mWM5k",
    defaultMessage: "Nothing on hand. Take some in on the Intake page.",
    description: "stock, no units",
  },
  location: {
    id: "PMhocV",
    defaultMessage: "Location",
    description: "stock, units column",
  },
  lot: {
    id: "4G66V3",
    defaultMessage: "Lot",
    description: "stock, units column",
  },
  quantity: {
    id: "g3gzKr",
    defaultMessage: "Qty",
    description: "stock, units column",
  },
  unitCost: {
    id: "PrDJ8Z",
    defaultMessage: "Unit cost",
    description: "stock, units column",
  },
  setReserve: {
    id: "MqA/CB",
    defaultMessage: "Set reserve",
    description: "stock, reserve button",
  },
  adjust: {
    id: "bdlf4z",
    defaultMessage: "Adjust count",
    description: "stock, adjust button",
  },
  history: {
    id: "Zdk3Nk",
    defaultMessage: "Ledger",
    description: "stock, link to the ledger for this sku",
  },
  reserveTitle: {
    id: "l8LIqb",
    defaultMessage: "Hold copies off the web",
    description: "reserve dialog title",
  },
  reserveQuantity: {
    id: "zmooS4",
    defaultMessage: "Reserved copies",
    description: "reserve dialog, quantity label",
  },
  reserveReason: {
    id: "+iv4Cr",
    defaultMessage: "Reason",
    description: "reserve dialog, reason label",
  },
  reserveSaved: {
    id: "AizyFe",
    defaultMessage: "Reserve saved",
    description: "reserve dialog, success notification",
  },
  adjustTitle: {
    id: "KVy1RY",
    defaultMessage: "Correct the count",
    description: "adjust dialog title",
  },
  adjustLocation: {
    id: "RV/Vat",
    defaultMessage: "Location code",
    description: "adjust dialog, location label",
  },
  adjustDelta: {
    id: "wn4mzj",
    defaultMessage: "Change (+ found, − gone)",
    description: "adjust dialog, delta label",
  },
  adjustReason: {
    id: "twE39w",
    defaultMessage: "Reason (required)",
    description: "adjust dialog, reason label",
  },
  adjustUnitCost: {
    id: "wzdfvW",
    defaultMessage: "Unit cost for copies found (blank: the average)",
    description: "adjust dialog, cost label",
  },
  adjustSaved: {
    id: "63G3SJ",
    defaultMessage: "Count corrected",
    description: "adjust dialog, success notification",
  },
});

export const locationMessages = defineMessages({
  subtitle: {
    id: "jD0hMP",
    defaultMessage:
      "Where stock sits: shelves, boxes, binders, pages and slots. A code is what the label carries.",
    description: "locations, subtitle",
  },
  create: {
    id: "pR/Flb",
    defaultMessage: "New location",
    description: "locations, create button",
  },
  searchPlaceholder: {
    id: "EQLfqp",
    defaultMessage: "Search code or name",
    description: "locations, search placeholder",
  },
  kind: {
    id: "qydEc4",
    defaultMessage: "Kind",
    description: "locations, kind filter and column",
  },
  kindAll: {
    id: "1aCOBJ",
    defaultMessage: "All kinds",
    description: "locations, kind filter: no filter",
  },
  rootsOnly: {
    id: "Vqpza0",
    defaultMessage: "Top level only",
    description: "locations, filter to roots",
  },
  code: {
    id: "7RRhBL",
    defaultMessage: "Code",
    description: "locations, column and field",
  },
  name: {
    id: "IxsdCl",
    defaultMessage: "Name",
    description: "locations, column and field",
  },
  parent: {
    id: "D9NYwo",
    defaultMessage: "Inside",
    description: "locations, parent column and field",
  },
  units: {
    id: "DZ9wG2",
    defaultMessage: "Copies",
    description: "locations, unit count column",
  },
  inactive: {
    id: "II6VTZ",
    defaultMessage: "Inactive",
    description: "locations, inactive tag",
  },
  empty: {
    id: "CdqIRM",
    defaultMessage: "No locations yet. Create one, or run attic_inventory_locations for a binder.",
    description: "locations, empty list",
  },
  noMatches: {
    id: "4SAktg",
    defaultMessage: "No locations match these filters.",
    description: "locations, empty filtered list",
  },
  detailsTitle: {
    id: "BmHA6P",
    defaultMessage: "Location",
    description: "location details, card title",
  },
  createTitle: {
    id: "KlXLRN",
    defaultMessage: "New location",
    description: "location create, page title",
  },
  parentHelp: {
    id: "4dogSq",
    defaultMessage: "The code of the location this one is inside; blank for a top-level one.",
    description: "location form, parent help",
  },
  isActive: {
    id: "D3B/2s",
    defaultMessage: "Accepts new stock",
    description: "location form, active switch",
  },
  isActiveHelp: {
    id: "WpdLgh",
    defaultMessage:
      "An inactive location refuses intake and moves in; what is in it can still leave.",
    description: "location form, active help",
  },
  notes: {
    id: "+FBum1",
    defaultMessage: "Notes",
    description: "location form, notes",
  },
  barcode: {
    id: "NR6AtY",
    defaultMessage: "Barcode",
    description: "location details, barcode label",
  },
  children: {
    id: "C7EgzL",
    defaultMessage: "Contains",
    description: "location details, children card title",
  },
  noChildren: {
    id: "U8lNae",
    defaultMessage: "No locations inside this one.",
    description: "location details, no children",
  },
  contents: {
    id: "UQrcwF",
    defaultMessage: "Stock here",
    description: "location details, units card title",
  },
  noContents: {
    id: "H4nVcE",
    defaultMessage: "Nothing is here.",
    description: "location details, no units",
  },
  saved: {
    id: "c0+M6Y",
    defaultMessage: "Location saved",
    description: "location, saved notification",
  },
  created: {
    id: "MbHpuC",
    defaultMessage: "Location created",
    description: "location, created notification",
  },
  notFound: {
    id: "fNfsfT",
    defaultMessage: "This location does not exist.",
    description: "location details, missing",
  },
  sku: {
    id: "ecIbWx",
    defaultMessage: "SKU",
    description: "location details, units column",
  },
});

export const lotMessages = defineMessages({
  subtitle: {
    id: "HOuzwE",
    defaultMessage:
      "Every intake, newest first, with what is still on hand from it and what that cost.",
    description: "lots, subtitle",
  },
  reference: {
    id: "YkiUKQ",
    defaultMessage: "Reference",
    description: "lots, column",
  },
  source: {
    id: "y8DxEn",
    defaultMessage: "Source",
    description: "lots, column",
  },
  supplier: {
    id: "kjsDCz",
    defaultMessage: "Supplier",
    description: "lots, column",
  },
  received: {
    id: "ouvARO",
    defaultMessage: "Received",
    description: "lots, column",
  },
  onHand: {
    id: "aMeIjL",
    defaultMessage: "Still on hand",
    description: "lots, column",
  },
  cost: {
    id: "hlkTM3",
    defaultMessage: "Cost on hand",
    description: "lots, column",
  },
  empty: {
    id: "oIH1t3",
    defaultMessage: "No lots yet. The first intake makes one.",
    description: "lots, empty list",
  },
  notFound: {
    id: "h/7PS9",
    defaultMessage: "This lot does not exist.",
    description: "lot details, missing",
  },
  unitsTitle: {
    id: "6YOUrT",
    defaultMessage: "Still on hand from this lot",
    description: "lot details, units card",
  },
  noUnits: {
    id: "CjdkbO",
    defaultMessage: "Everything from this lot has left.",
    description: "lot details, no units",
  },
  notes: {
    id: "S+523y",
    defaultMessage: "Notes",
    description: "lot details, notes",
  },
  untitled: {
    id: "Tnyxj1",
    defaultMessage: "Lot",
    description: "lots, a lot with no reference",
  },
});

export const intakeMessages = defineMessages({
  subtitle: {
    id: "e92hS+",
    defaultMessage:
      "Stock arrives. One lot for the purchase; a line per SKU, location and unit cost. Saleor's stock goes up when it is saved.",
    description: "intake, subtitle",
  },
  lotTitle: {
    id: "ZITU0s",
    defaultMessage: "Lot",
    description: "intake, lot card title",
  },
  linesTitle: {
    id: "NKDfqC",
    defaultMessage: "Lines",
    description: "intake, lines card title",
  },
  reference: {
    id: "3i6Ob0",
    defaultMessage: "Reference (invoice, ticket, show)",
    description: "intake, reference field",
  },
  source: {
    id: "P1JPFf",
    defaultMessage: "Source",
    description: "intake, source field",
  },
  supplier: {
    id: "84WykX",
    defaultMessage: "Supplier",
    description: "intake, supplier field",
  },
  currency: {
    id: "EJjg1m",
    defaultMessage: "Currency",
    description: "intake, currency field",
  },
  notes: {
    id: "lk/WYP",
    defaultMessage: "Notes",
    description: "intake, notes field",
  },
  sku: {
    id: "Np8HbV",
    defaultMessage: "SKU",
    description: "intake, line field",
  },
  location: {
    id: "UCfwig",
    defaultMessage: "Location code",
    description: "intake, line field",
  },
  quantity: {
    id: "jSG34d",
    defaultMessage: "Qty",
    description: "intake, line field",
  },
  unitCost: {
    id: "579Dp6",
    defaultMessage: "Unit cost",
    description: "intake, line field",
  },
  addLine: {
    id: "3c3pWd",
    defaultMessage: "Add line",
    description: "intake, add line button",
  },
  removeLine: {
    id: "RlXMQG",
    defaultMessage: "Remove line {index}",
    description: "intake, remove line button label",
  },
  total: {
    id: "FCvalj",
    defaultMessage: "{units} copies, {cost} total",
    description: "intake, running total",
  },
  save: {
    id: "WHbseg",
    defaultMessage: "Take in",
    description: "intake, save button",
  },
  saved: {
    id: "0z5IaD",
    defaultMessage: "Stock taken in",
    description: "intake, success notification",
  },
  lineError: {
    id: "BpGyYF",
    defaultMessage: "Line {index}: {message}",
    description: "intake, error attributed to a line",
  },
});

export const ledgerMessages = defineMessages({
  subtitle: {
    id: "cCDlMk",
    defaultMessage:
      "Every change to stock: who, why, how much and where the numbers stood afterwards. Rows are written by the server and never change.",
    description: "ledger, subtitle",
  },
  skuPlaceholder: {
    id: "Xr8ScH",
    defaultMessage: "SKU",
    description: "ledger, sku filter placeholder",
  },
  locationPlaceholder: {
    id: "at5WFH",
    defaultMessage: "Location code",
    description: "ledger, location filter placeholder",
  },
  kind: {
    id: "iDnTZP",
    defaultMessage: "Kind",
    description: "ledger, kind filter",
  },
  kindAll: {
    id: "pSHjQ2",
    defaultMessage: "All",
    description: "ledger, kind filter: every kind",
  },
  when: {
    id: "+Jug6q",
    defaultMessage: "When",
    description: "ledger, column",
  },
  who: {
    id: "R5gZOS",
    defaultMessage: "Who",
    description: "ledger, column",
  },
  what: {
    id: "90Tfn2",
    defaultMessage: "What",
    description: "ledger, column",
  },
  change: {
    id: "5JSPbX",
    defaultMessage: "Change",
    description: "ledger, column: on hand delta",
  },
  after: {
    id: "p2bHSl",
    defaultMessage: "After (on hand / reserved / sellable)",
    description: "ledger, column",
  },
  reason: {
    id: "64p7Jh",
    defaultMessage: "Reason",
    description: "ledger, column",
  },
  system: {
    id: "TnJExQ",
    defaultMessage: "System",
    description: "ledger, nobody did it",
  },
  fromTo: {
    id: "2+S3Dx",
    defaultMessage: "{from} → {to}",
    description: "ledger, a move's locations",
  },
  reserveDelta: {
    id: "3N4AAP",
    defaultMessage: "reserve {delta}",
    description: "ledger, a reserve change",
  },
  empty: {
    id: "awz0qf",
    defaultMessage: "Nothing has moved yet.",
    description: "ledger, empty",
  },
  noMatches: {
    id: "Hrmu7y",
    defaultMessage: "No movements match these filters.",
    description: "ledger, empty filtered",
  },
});

export const kindMessages = defineMessages({
  SHELF: { id: "or/cpm", defaultMessage: "Shelf", description: "location kind" },
  BOX: { id: "5JEy8Z", defaultMessage: "Box", description: "location kind" },
  ROW: { id: "QBwQmS", defaultMessage: "Row", description: "location kind" },
  BINDER: { id: "rsb/aT", defaultMessage: "Binder", description: "location kind" },
  PAGE: { id: "WAPHwd", defaultMessage: "Page", description: "location kind" },
  SLOT: { id: "hw+SAu", defaultMessage: "Slot", description: "location kind" },
  CASE: { id: "ie3zqs", defaultMessage: "Display case", description: "location kind" },
  OTHER: { id: "WpVORI", defaultMessage: "Other", description: "location kind" },
});

export const sourceMessages = defineMessages({
  DISTRIBUTOR: { id: "bkCuHI", defaultMessage: "Distributor", description: "lot source" },
  BUYLIST: { id: "Qg6n5F", defaultMessage: "Buylist", description: "lot source" },
  SHOW: { id: "OlEoKd", defaultMessage: "Show or event", description: "lot source" },
  RETAIL: { id: "sNQJLu", defaultMessage: "Retail purchase", description: "lot source" },
  OPENED: { id: "yecEhj", defaultMessage: "Opened sealed product", description: "lot source" },
  FOUND: { id: "UIWPQo", defaultMessage: "Count correction", description: "lot source" },
  OTHER: { id: "nGLXS2", defaultMessage: "Other", description: "lot source" },
});

export const movementKindMessages = defineMessages({
  INTAKE: { id: "gDCxyY", defaultMessage: "Intake", description: "movement kind" },
  MOVE: { id: "PldEFx", defaultMessage: "Move", description: "movement kind" },
  ADJUST: { id: "dMguXV", defaultMessage: "Adjustment", description: "movement kind" },
  PICK: { id: "8TrOJY", defaultMessage: "Pick", description: "movement kind" },
  RESERVE: { id: "eXOG4R", defaultMessage: "Reserve changed", description: "movement kind" },
  SYNC: { id: "6qKiZF", defaultMessage: "Saleor stock written", description: "movement kind" },
});
